export const normalize = (val: string) => {
  let number = val;
  if (number.startsWith('+1 ')) number = number.replace('+1 ', '');
  if (number.startsWith('+1')) number = number.replace('+1', '');
  const digits = number.replace(/[^\d]/g, '');
  if (!digits.length) return '';
  number = '';
  if (digits.length >= 1) number += '(';
  number += digits.slice(0, 3);
  if (digits.length >= 4) number += ') ';
  number += digits.slice(3, 6);
  if (digits.length >= 7) number += '-';
  number += digits.slice(6, 10);
  return number;
};
